import { Suspense, lazy, useState, useEffect } from "react";
import { Column } from "../../../../core/components/Column";
import sal from "sal.js";
import "sal.js/dist/sal.css";
import { CircleLoading2 } from "../../../../core/icons/CricleLoading2";

const Gift = lazy(() => import("../components/Gift").then((module) => ({ default: module.Gift })));
const Honor = lazy(() => import("../components/Honor").then((module) => ({ default: module.Honor })));
const Introduction = lazy(() => import("../components/Introduction").then((module) => ({ default: module.Introduction })));
const Mapa = lazy(() => import("../components/Map").then((module) => ({ default: module.Mapa })));
const Photo = lazy(() => import("../components/Photo").then((module) => ({ default: module.Photo })));
const Phrase = lazy(() => import("../components/Phrase").then((module) => ({ default: module.Phrase })));
const DressCode = lazy(() => import("../components/DressCode").then((module) => ({ default: module.DressCode })));
const Countdown = lazy(() => import("../components/time").then((module) => ({ default: module.Countdown })));
const Phrase2 = lazy(() => import("../components/Phrase2").then((module) => ({ default: module.Phrase2 })));
const AssistanceTitle = lazy(() => import("../components/AssistanceTitle").then((module) => ({ default: module.AssistanceTitle })));
const Assistance = lazy(() => import("../components/Assistance").then((module) => ({ default: module.Assistance })));
const MusicSendTitle = lazy(() => import("../components/MusicSendTitle").then((module) => ({ default: module.MusicSendTitle })));
const MusicSend = lazy(() => import("../components/MusicSend").then((module) => ({ default: module.MusicSend })));
const Gallery = lazy(() => import("../components/Gallery").then((module) => ({ default: module.Gallery })));

const Loading: React.FC = () => (
	<Column
		mainAxisAlignment="center"
		crossAxisAlignment="center"
		className="bg-gray-200 text-[#03649C] h-svh flex justify-center items-center"
	>
		<p className="text-xl mb-4 px-14 text-center">Cargando invitación de Josselin Jazmin</p>
		<CircleLoading2
			className="w-20 h-20"
			strokeColor="#03649C"
		/>
	</Column>
);

export const HomeScreen: React.FC = () => {
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		if (!loading) {
			const salInstance = sal({
				once: true,
				root: null,
			});

			return () => {
				salInstance.disable();
			};
		}
	}, [loading]);

	const handleOnLoad = () => {
		setLoading(false);
	};

	return (
		<Suspense fallback={<Loading />}>
			<Column
				crossAxisAlignment="center"
				className="gap-5 min-h-svh text-secondary font-description"
				onLoad={handleOnLoad}
			>
				<Introduction />
				<Photo />
				<Countdown />
				<Honor />
				<Phrase />
				<Mapa />
				<Gift />
				<DressCode />
				<Phrase2 />
				<AssistanceTitle />
				<Assistance />
				<MusicSendTitle />
				<MusicSend />
				<Gallery />
			</Column>
		</Suspense>
	);
};
